// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"PropertyGeneralSettings_tableContainer__3ihZv","addContact":"PropertyGeneralSettings_addContact__3vxtB","ModalDialog":"PropertyGeneralSettings_ModalDialog__2PRrM"};